var moduleMap = {
	"./AppointmentModule": () => {
		return Promise.all([__webpack_require__.e(6122), __webpack_require__.e(4229), __webpack_require__.e(7714), __webpack_require__.e(3053)]).then(() => (() => ((__webpack_require__(3053)))));
	},
	"./AppointmentQueue": () => {
		return Promise.all([__webpack_require__.e(5985), __webpack_require__.e(1489), __webpack_require__.e(7436), __webpack_require__.e(1837), __webpack_require__.e(5676), __webpack_require__.e(6122), __webpack_require__.e(7714), __webpack_require__.e(4687), __webpack_require__.e(440)]).then(() => (() => ((__webpack_require__(1767)))));
	},
	"./AppointmentCalendar": () => {
		return Promise.all([__webpack_require__.e(1724), __webpack_require__.e(5985), __webpack_require__.e(9278), __webpack_require__.e(1489), __webpack_require__.e(7436), __webpack_require__.e(1837), __webpack_require__.e(5676), __webpack_require__.e(6122), __webpack_require__.e(9438), __webpack_require__.e(4229), __webpack_require__.e(3499), __webpack_require__.e(7714), __webpack_require__.e(7278), __webpack_require__.e(9324), __webpack_require__.e(9915)]).then(() => (() => ((__webpack_require__(9324)))));
	},
	"./AppointmentList": () => {
		return Promise.all([__webpack_require__.e(1724), __webpack_require__.e(5985), __webpack_require__.e(7864), __webpack_require__.e(1489), __webpack_require__.e(7436), __webpack_require__.e(1837), __webpack_require__.e(5676), __webpack_require__.e(6122), __webpack_require__.e(9438), __webpack_require__.e(4229), __webpack_require__.e(3499), __webpack_require__.e(7714), __webpack_require__.e(1269), __webpack_require__.e(5699)]).then(() => (() => ((__webpack_require__(5154)))));
	},
	"./AppointmentBookingModal": () => {
		return Promise.all([__webpack_require__.e(1724), __webpack_require__.e(5985), __webpack_require__.e(1489), __webpack_require__.e(7436), __webpack_require__.e(1837), __webpack_require__.e(5676), __webpack_require__.e(6122), __webpack_require__.e(9438), __webpack_require__.e(3499), __webpack_require__.e(97)]).then(() => (() => ((__webpack_require__(4850)))));
	},
	"./TraKetQua": () => {
		return Promise.all([__webpack_require__.e(5985), __webpack_require__.e(1489), __webpack_require__.e(7436), __webpack_require__.e(5676), __webpack_require__.e(6122), __webpack_require__.e(7110), __webpack_require__.e(184)]).then(() => (() => ((__webpack_require__(7110)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});